import { DetailedHTMLProps, ImgHTMLAttributes, useState } from 'react';
import imgDefault from '@/assets/images/png/default-user-pic-2.png';
import { broadcastService } from '@/services';
import { cn } from '@/lib/utils';

type TProps = Omit<DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement>, 'onClick'> & {
  onClick?: (params: { e?: any; isError: boolean; }) => void;
  enableFullScreen?: boolean;
};

const ImgUserPicture = ({ enableFullScreen, ...props }: TProps) => {

  const [state, setState] = useState<'error' | undefined>();

  const handleOnClick = (e: any) => {
    // call function
    props?.onClick?.({ e, isError: state === 'error' });
    // show full screen
    enableFullScreen &&
      props?.src &&
      state !== 'error' &&
      broadcastService
        .photoViewer
        .show(
          [props.src],
          { photoClosable: true }
        );
  };

  return (
    <img
      {...props}
      onClick={handleOnClick}
      className={cn(
        props?.className,
        state === 'error'
      )}
      onError={
        e => {
          const htmlImageElement = e.target as HTMLImageElement;
          htmlImageElement.onerror = null;
          htmlImageElement.src = imgDefault;
          setState('error');
        }
      } />
  );

};

export default ImgUserPicture;
